import { createFileRoute, redirect } from '@tanstack/react-router'
import { PurchasingHome } from '@/features/purchasing-home/purchasing-home'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the Purchasing module home, at `/purchasing`. It has no
 * page of its own: the guard is the module's Overview grant, and the render is
 * the feature component. The rail's Purchasing tile leads here.
 */
export const Route = createFileRoute('/_authenticated/purchasing/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'purchase_order.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: PurchasingHome,
})
